var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImageAddIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9058 19.0156L14.148 7.8125C13.9332 7.45703 13.4449 7.39453 13.1519 7.6875L8.78864 12.0391L7.18707 10.4414C6.8941 10.1484 6.40582 10.207 6.19098 10.5664L1.09332 19.0156C0.831604 19.4453 1.1402 20 1.6402 20H20.355C20.8589 20 21.1636 19.4453 20.9058 19.0156ZM7.24957 3.11719C7.24957 7.29297 0.999573 7.29297 0.999573 3.11719C0.999573 -1.04297 7.24957 -1.03516 7.24957 3.11719Z",
    fill: "#BEBECE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageAddIcon);
export default __webpack_public_path__ + "static/media/ImageAddIcon.022542c73de7fa6e06a8b13a80fbed7b.svg";
export { ForwardRef as ReactComponent };